import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Tabs, TabsList, TabsTrigger } from '@/ui/primitives';
import { PageShell } from '@/ui/layout';
import { RelatoriosCardsView } from '@/modules/crm/components/CrmRelatoriosTab';
import { TabBadgeTarefas } from '@/modules/crm/components/TabBadgeTarefas';

export const Route = createFileRoute('/_authed/crm_/relatorios')({
  component: CrmRelatoriosPage,
});

function CrmRelatoriosPage() {
  const navigate = useNavigate();
  return (
    <PageShell
      eyebrow="Comercial"
      title="Oportunidades"
      lead="Pendências do diagnóstico viram oportunidade comercial."
    >
      <Tabs
        value="relatorios"
        onValueChange={(v) => {
          if (v === 'oportunidades') void navigate({ to: '/crm' });
          else if (v === 'lista') void navigate({ to: '/crm/lista' });
          else if (v === 'minhas-tarefas') void navigate({ to: '/crm/minhas-tarefas' });
        }}
      >
        <TabsList>
          <TabsTrigger value="oportunidades">Kanban</TabsTrigger>
          <TabsTrigger value="lista">Lista</TabsTrigger>
          <TabsTrigger value="minhas-tarefas">
            Minhas tarefas
            <TabBadgeTarefas />
          </TabsTrigger>
          <TabsTrigger value="relatorios">Relatórios</TabsTrigger>
        </TabsList>
      </Tabs>
      <RelatoriosCardsView />
    </PageShell>
  );
}
